/**
 * @file Contains customization for MuiButton Component
 */

import { Components } from '@mui/material';

import { colorError, colorNeutral, colorPrimary } from '../colors';

const MuiButton: Components['MuiButton'] = {
  defaultProps: {
    disableRipple: true, // issues with how the ripple looks like when custom styles applied due to border radius
  },
  styleOverrides: {
    root: {
      '&:focus-visible': {
        boxShadow: 'none',
      },
      borderRadius: 100,
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  variants: [
    {
      props: { color: 'primary' },
      style: {
        '&:focus-visible': {
          backgroundColor: colorPrimary[100],
        },
        '&:hover': {
          backgroundColor: colorPrimary[50],
        },
      },
    },
    {
      props: { color: 'neutral' },
      style: {
        '&:focus-visible': {
          backgroundColor: colorNeutral[500],
        },
        '&:hover': {
          backgroundColor: colorNeutral[400],
        },
        backgroundColor: colorNeutral[300],
        color: colorNeutral[800],
      },
    },
    {
      props: { color: 'primary', variant: 'contained' },
      style: {
        '&:focus-visible': {
          backgroundColor: colorPrimary[700],
        },
        '&:hover': {
          backgroundColor: colorPrimary[800],
        },
      },
    },
    {
      props: { color: 'primary', variant: 'text' },
      style: {
        '&:focus-visible': {
          backgroundColor: colorNeutral[300],
        },
        '&:hover': {
          backgroundColor: colorNeutral[200],
        },
      },
    },
    {
      props: { color: 'neutral', variant: 'outlined' },
      style: {
        '&:active': {
          backgroundColor: colorNeutral[200],
        },
        '&:focus-visible': {
          border: '1px solid ' + colorNeutral[800],
        },
        '&:hover': {
          backgroundColor: colorNeutral[200],
          border: '1px solid ' + colorNeutral[800],
        },
        backgroundColor: colorNeutral[100],
        border: '1px solid ' + colorNeutral[500],
        color: colorNeutral[800],
      },
    },
    {
      props: { color: 'error', variant: 'text' },
      style: {
        '&:hover': {
          backgroundColor: colorNeutral[100],
        },
        color: colorError[300],
      },
    },
    {
      props: { color: 'neutral', variant: 'contained' },
      style: {
        '&:active': {
          backgroundColor: colorNeutral[200],
        },
        '&:focus-visible': {
          border: '1px solid ' + colorNeutral[800],
        },
        '&:hover': {
          backgroundColor: colorNeutral[400],
          boxShadow: 'var(--elevation-3)',
        },
        backgroundColor: colorNeutral[300],
        border: '1px solid ' + colorNeutral[500],
        color: colorNeutral[800],
      },
    },
  ],
};

export default MuiButton;
